import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';

import { type StreamFns } from '../../../../pm-plugins/in-editor-direct-streaming/hooks/useInEditorDirectStreaming';
import { useAIExperienceCommonDataContext } from '../../../hooks/useAIExperienceCommonData';
import { useAnalyticsFlowEventsQueue } from '../../../utils/analytics/analyticsFlowUtils';
import type { ErrorInfo } from '../../../utils/error-handling';
import { ErrorMessage } from '../../../utils/error-handling';
import { FAILURE_REASON } from '../../../utils/errors';
import { type ContextStatistics } from '../../../utils/xstate/get-ai-experience-service';

export function InvalidInputScreenWithLogic({
	errorInfo,
	commitStream,
	contextStatistics,
}: {
	commitStream?: StreamFns['commitStream'];
	contextStatistics?: ContextStatistics;
	errorInfo: ErrorInfo;
}) {
	const aiExperienceCommonData = useAIExperienceCommonDataContext();
	const { endExperience } = aiExperienceCommonData;

	useAnalyticsFlowEventsQueue({
		stepName: 'invalidInput',
		attributes: {
			reason: errorInfo.failureReason ?? FAILURE_REASON.UNKNOWN,
			modelIO: {
				contextStatistics,
			},
		},
	});

	return (
		<ErrorScreen
			text={ErrorMessage(errorInfo)}
			onCancel={() => {
				if (fg('aifc_create_enabled')) {
					commitStream?.();
				}
				endExperience();
			}}
		/>
	);
}
